import React from 'react';
import {Link} from 'react-router-dom'
import {Modal, Button} from 'react-bootstrap'

import AddDiscount from '../discount/adddiscount'
import AddUnit from '../unit/addunit'
import AddGst from '../gst/addgst'
export class AddItemButton extends React.Component {
  render() {
    return (<Link to="/items/create" className="btn btn-primary">Create New Item
  </Link>)

  }
}



export class AddGstModal extends React.Component {
  constructor(props) {
    super(props)

    this.handleClose = this.handleClose.bind(this);

  }
  handleClose() {
    this.props.handleModalToggle()
  }


  render() {

    let show = this.props.show
    const modal = (
        <Modal show={show} onHide={this.handleClose}>

          <Modal.Body>
            <AddGst onAddCallback={this.props.onAddCallback} />
          </Modal.Body>
        </Modal>
    )
    return   <span>
        {modal}
    </span>
  }
}


export class AddUnitModal extends React.Component {
  constructor(props) {
    super(props)

    this.handleClose = this.handleClose.bind(this);

  }
  handleClose() {
    this.props.handleModalToggle()
  }


  render() {

    let show = this.props.show
    const modal = (
        <Modal show={show} onHide={this.handleClose}>

          <Modal.Body>
            <AddUnit onAddCallback={this.props.onAddCallback} />
          </Modal.Body>

        </Modal>
    )
    return   <span>
        {modal}
    </span>
  }
}

export class AddDiscountModal extends React.Component {
  constructor(props) {
    super(props)

    this.handleShow = this.handleShow.bind(this);
    this.handleClose = this.handleClose.bind(this);
    this.state = {show: true}
  }
  handleClose() {

    if(typeof this.props.handleDiscount !== "undefined") {
      this.props.handleDiscount()
    }

    this.setState({ show: false });
  }

  handleShow() {
    this.setState({ show: true });
  }

  render() {

    let show = this.state.show
    const modal = (
        <Modal show={show} onHide={this.handleClose}>

          <Modal.Body>
            <AddDiscount onAddCallback={this.props.onAddCallback} />
          </Modal.Body>

        </Modal>
    )
    return   <span>
        {modal}
    </span>
  }

}



export function BasicRate(selling_price, gst_pct){

  let basicRate = parseFloat((selling_price * 100) / (100+gst_pct)).toFixed(2)
  return parseFloat(basicRate)
}

export function ItemFinalBill(props) {
  const parentState = props.state
  const gsts = props.gsts
  let mrp = parentState.mrp, selling_price = parentState.selling_price, gst=parentState.gst

  let statement
  if (typeof gst !== "undefined" && typeof mrp !== "undefined") {
      let gst_object
      gsts.forEach((g,i)=>{
        if(g.id === gst) {
          gst_object = g
          const gstPct = gst_object.type === "I" ? gst_object.igst : (gst_object.cgst + gst_object.sgst)

          let basicRate

          let calculatedFinalPrice

          basicRate = BasicRate(selling_price, gstPct)


          calculatedFinalPrice = basicRate + (basicRate * gstPct/100)
          calculatedFinalPrice = parseFloat(calculatedFinalPrice).toFixed(2)


          statement = <ul className="list-inline">
                      <li>{"Basic Price (" + basicRate + ")"}</li>
                      <li>{gst_object.name}</li>
                      <li>{"Final Price " + calculatedFinalPrice}</li>
                    </ul>
        return statement
        }
      })

      return statement

  }
  else {
    return null
  }


}

export class BarCodeInput extends React.Component {

  constructor() {
    super()
    this.state = {value:''}

  }

  static defaultProps = {maxDelay:1000}
 //  componentWillReceiveProps(nextProps) {
 //   if (nextProps.item !== this.props.item) {
 //     //Forcibly overwrite input value to new default if the default ever changes
 //
 //     let item = nextProps.item
 //
 //     if(item && item[this.props.name]) {
 //
 //       this.setState({value:''})
 //
 //     }
 //     else {
 //       this.setState({value:''})
 //     }
 //   }
 // }

 componentDidMount() {
   let item = this.props.item
   if(item) {
     if(item && item[this.props.name]) {

        this.setState({value:item[this.props.name]})
     }
   }
 }
 lastTime = 0
 handleInputChange = (e) => {
   const { maxDelay } = this.props
   const now = Date.now()
   const delay = now - this.lastTime
   const value = e.target.value

   if (delay <= maxDelay || this.lastTime === 0) {
     this.setState(() => ({
       value: value
     }))

     this.lastTime = now
     setTimeout(() => {
       if (this.state.value.length < 2) this.clearValue()
     }, maxDelay * 2)

     return null
   }

   if (delay > maxDelay) this.clearValue()
 }

 clearValue = () => {
   this.setState(() => ({
     value: ''
   }))
   this.resetLastTime()
 }

 handleInputKeyUp = (e) => {
   e.preventDefault()
   console.log(e);
   const keyCode = e.keyCode
   let v= this.state.value
   if (keyCode === 8) {
     this.setState({
       value: ''
     })
     v = ''
     this.resetLastTime()
   }
   let item = this.props.item
   item[this.props.name] =v

   this.props.onChangeCallback(item, e)

   // if (keyCode === 13) {
   //
   //   // Handle Enter
   //   let item = this.props.item
   //
   //   item[this.props.name] = this.state.value
   //
   //
   //   // var evt = new KeyboardEvent('keydown', {key:'Tab',
   //   //        bubbles:true})
   //   // document.dispatchEvent (evt);
   //
   //
   //   this.props.onChangeCallback(item)
   //   this.resetLastTime()
   //   if(this.props.next_focus) {
   //     let next_id = this.props.next_focus
   //     if(this.props.item) {
   //       next_id = next_id + this.props.item.serial
   //     }
   //      document.getElementById(next_id).focus()
   //   }
   // }
 }

 resetLastTime = () => {
   this.lastTime = 0
   this.input.select()
 }

 render() {
   const { value } = this.state
   let id = this.props.name
   if(this.props.item) {
     id = id + this.props.item.serial
   }
   return (
     <div>
       <input className="form-control" placeholder={this.props.name}
         ref={input => this.input = input} id={id}
         value={value}
         onChange={this.handleInputChange}
         onKeyUp={this.handleInputKeyUp}
       />
     </div>
   );
 }

}

export class DeleteItemButton extends React.Component {
  constructor(props) {
    super(props)
    this.state = {}
    this.handleShow = this.handleShow.bind(this);
    this.handleClose = this.handleClose.bind(this);
    this.handleDelete = this.handleDelete.bind(this);
    this.state = {show: false}
  }
  handleDelete() {
    this.setState({show:false})
    this.props.handleDelete()
  }
  handleClose() {
    this.setState({ show: false });
  }

  handleShow() {
    this.setState({ show: true });
  }

  render() {
    const selectedRows = this.props.selectedRows

    let show = this.state.show
    let btn
    if(typeof this.props.item.deleting_items !== "undefined" && this.props.item.deleting_items) {
      show = false
      btn =   <button className="btn btn-danger" disabled>Deleting... </button>
    }
    else {
      btn = (<button className="btn btn-danger" onClick={this.handleShow}>Delete {selectedRows.length}</button>)
    }




    const modal = (
        <Modal show={show} onHide={this.handleClose}>
          <Modal.Header closeButton>
           <Modal.Title>Confirm Delete</Modal.Title>
         </Modal.Header>
          <Modal.Body>
            Total {selectedRows.length} {selectedRows.length === 1 ? "row": "rows" } selected
          </Modal.Body>
          <Modal.Footer>
           <Button onClick={this.handleClose}>Close</Button>
           <Button onClick={this.handleDelete} bsStyle="danger">Delete</Button>
         </Modal.Footer>
        </Modal>
    )

    if(selectedRows.length > 0) {
      return (
        <span>
          {modal}
          {btn}

      </span>

)
    }
    return null

  }
}



// WEBPACK FOOTER //
// ./src/components/item/utils.js